<template>
  <div class="relative" style="margin-left: 3%; margin-right: 3%; ">

    <title-w-star title="services.compareOurHealthPackages" :titleColor="'#603813'"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }" />

    <img src="@/assets/images/shared/starGroupIconBrownRightSmallS2.svg" style="width: 9.5vw; top: 10%"
      class="absolute right-0 -z-10" />
    <img src="@/assets/images/shared/starGroupIconBrownLeftSmallS2.svg" style="width: 5vw; bottom: 15%"
      class="absolute left-0 -z-10" />

    <!-- <table class="m-14 p-20 bg-white font-jost">
      <thead>
        <tr>
          <th class="px-24 border-r  first:border-0"></th>
          <th v-for="(item, index) in servicesStore.ourHealthPackagesList" :key="'ourHealthPackages' + index"
            class="px-24 border-r">

            <div v-on:click="downloadPDF(item.attachment)" class="text-4xl font-bold text-deep-green underline" id="packageTitle">{{ t(item.label) }}</div>

            <div class="text-3xl">{{ currancyFormatter(item.price) }}</div>
            <div class="relative flex justify-center space-x-4 text-lg mt-7">
              <img src="@/assets/images/services/initialConsultIcon.svg" style="width: 1.5vw"
                @mouseover="servicesStore.isHoverConsult = true; servicesStore.curHoverTarget = index;"
                @mouseleave="servicesStore.isHoverConsult = false; servicesStore.curHoverTarget = null;" />
              <span class="font-bold">
                <div>{{ t(item.consultDuration) }}</div>
                <div>mins</div>
              </span>
              <div class="text-base absolute rounded-xl text-dark-brown px-4 py-0.5 whitespace-nowrap"
                style="bottom: -0.7vw; left: 1.5vw; background: rgba(255, 232, 194, 0.6)"
                v-if="servicesStore.isHoverConsult && servicesStore.curHoverTarget == index">
                <span>{{ t("services.initialConsult") }}</span>
              </div>
            </div>

            <div class="relative flex justify-center space-x-4 text-lg mt-5">
              <img src="@/assets/images/services/followUpIcon.svg" style="width: 1.5vw"
                @mouseover="servicesStore.isHoverFollowUp = true; servicesStore.curHoverTarget = index;"
                @mouseleave="servicesStore.isHoverFollowUp = false; servicesStore.curHoverTarget = null;" />
              <span class="font-bold">
                <div>{{ t(item.followUpDuration) }}</div>
                <div>mins</div>
              </span>
              <div class="text-base absolute rounded-xl text-dark-brown px-4 py-0.5 whitespace-nowrap"
                style="bottom: -0.7vw; left: 1.5vw; background: rgba(255, 232, 194, 0.6)"
                v-if="servicesStore.isHoverFollowUp && servicesStore.curHoverTarget == index">
                <span>{{ t("services.followUp") }}</span>
              </div>
            </div>
            <button-util buttonType="button" bgColor="#215650" labelColor="#FFE8C2" class="my-2.5"
              :buttonIcon="{ componentName: 'services', imgName: 'calendar', imgFormat: 'svg', width: '0.8vw' }"
              label="services.bookNowBtn" @click="routeTo('bookyourappointment')" />
          </th>
        </tr>
      </thead>
      <tbody>

        ## Render the first row without a collapsible section
        <template v-for="(item, index) in servicesStore.healthPackagesDetailList" :key="'healthPackagesDetail' + index">

          ## Header row
          <tr v-if="item.isHeader" :class="getToggleColor(item)"> 
            <th class="mx-10 mt-8 text-3xl relative" :colspan="servicesStore.ourHealthPackagesList.length+1">
              {{ t(item.label) }}
              <button-util class="!absolute inset-y-0 right-0 " bgColor="transparent" @click="toggleDetail(item)"
                :buttonIcon="getToggleButtonIcon(item)">
              </button-util>
            </th>
          </tr>

          <tr v-else-if="servicesStore.healthDetailToggleList.includes(item.headerGroupKey)">
            <th class="mx-10 mt-8 text-lg">{{ t(item.label) }}</th>

            <template v-for="(element, index) in servicesStore.ourHealthPackagesList" :key="'PackagesCode' + index">
              <td v-if="index%2 == 0" style="background-color: #E1F9F7;" class="!border-r-transparent">
                <button-util v-if="item.includePackagesList?.includes(element.packageCode)" buttonType="button" bgColor="transparent"
                  labelColor="#FFE8C2" class="!px-40 cursor-default"
                  :buttonIcon="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg', width: '2vw' }" />
              </td>

              <td v-else style="background-color: #BFDAD8;" class="!border-r-transparent">
                <button-util v-if="item.includePackagesList?.includes(element.packageCode)" buttonType="button" bgColor="transparent"
                  labelColor="#FFE8C2" class="!px-40 cursor-default"
                  :buttonIcon="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg', width: '2vw' }" />
              </td>
            </template>
          </tr>

        </template>
        
        <tr>
          <td class="border-transparent" colspan="5">
            <span class="flex">
              *
              <button-util buttonType="button" bgColor="transparent" labelColor="#0099FF" class="!px-0"
                label="services.maleExclusiveCheckUp"  id="exclusiveCheckUp"
                :buttonIcon="{ componentName: 'services', imgName: 'blueMan', imgFormat: 'svg', width: '1.5vw' }" />

              <span class="flex px-7">
                *
                <button-util buttonType="button" bgColor="transparent" labelColor="#FC5555" class="!px-0"
                  label="services.femaleExclusiveCheckUp" id="exclusiveCheckUp"
                  :buttonIcon="{ componentName: 'services', imgName: 'female', imgFormat: 'svg', width: '1.5vw' }" />
              </span>
            </span>
          </td>
        </tr>

      </tbody>
    </table> -->

    <table class="p-20 bg-white font-jost" style="text-align: center;">
        <thead>
          <th class="px-24 border-r  first:border-0"></th>
          <th class="px-24 border-r  border-0"></th>
          <th v-for="(item, index) in servicesStore.allPlanInfo" :key="item.code" class="px-24 border-r">
            <div v-on:click="downloadPDF(item.attachment)" class="text-4xl font-bold text-deep-green underline" id="packageTitle">{{ t(item.name) }}</div>
            <div style="color: #603813; font-weight: normal; font-size: 1.6vw;">{{ currancyFormatter(item.price) }}</div>
            
            <button-util buttonType="button" bgColor="#215650" labelColor="#FFE8C2" class="my-2.5"
              :buttonIcon="{ componentName: 'services', imgName: 'calendar', imgFormat: 'svg', width: '1vw' }"
              label="services.bookNowBtn" @click="routeTo('bookyourappointment')"
              style="margin-left: 14%"/>
          </th>
        </thead>

        <tbody>
          <template v-for="(item, index) in servicesStore.allPlanItemInfo" :key="index">
            <!-- category header-->
            <tr v-if="generateCategory(item)" :class="newGetToggleColor(item.category)" @click="toggleCollapse(item.category)" class="cursor-pointer"> 
              <th class="mx-10 mt-8 text-3xl relative py-2"  :colspan="servicesStore.allPlanInfo.length+2">
                {{ showCategoryName(item.category) }}
                <button-util class="!absolute inset-y-0 right-0 " bgColor="transparent"
                  :buttonIcon="newGetToggleButtonIcon(item.category)">
                </button-util>
              </th>
            </tr>

            <tr style="height: 6vw;" v-if="checkIfNeedCollapse(item)">

              <td style="vertical-align: top; padding-top: 1.2vw;" v-if="shouldRenderCell(item.groupName, index)" :rowspan="calculateRowspan(item.groupName, index)" :colspan="calculateColspan(item.groupName, item.itemName)">
                <span class="text-xl">{{ item.groupName }} <br> {{ item.groupNameChinese }}</span></td>

              <td v-if="isSameNameasGroup(item.groupName, item.itemName)"><span class="text-xl">{{ item.itemName }} <br> {{ item.itemNameChinese }}</span></td>

              <td v-for="(planItem, planIndex) in servicesStore.allPlanInfo" :style="{ backgroundColor: setCellBackgroundColor(planIndex) }" class="!border-r-transparent" style="width: 20vw;">
                <!-- Included in Plan -->
                <button-util v-if="showStarOrNot(item, planIndex)" buttonType="button" bgColor="transparent"
                labelColor="#FFE8C2" class="!px-40 cursor-default"
                :buttonIcon="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg', width: '2vw' }"
                style="margin-left: 6%;"/>
                
                <!-- Choice in Plan -->
                <button-util v-if="showChoiceOrNot(item, planIndex)" buttonType="button" bgColor="transparent"
                  labelColor="#137D61" class="!px-40 cursor-default" style="display: flex; align-items: center;">
                  <div style="display: flex; align-items: center;">
                    <div>
                      <span style="color: #137D61; display: flex; justify-content: center; align-items: center; width: 2vw; height: 2vw; border: 0.15vw dashed #137D61; border-radius: 50%;">
                        <span style="display: flex; justify-content: center; align-items: center; height: 80%; width: 80%;">{{ showChoiceLabel(item, planIndex) }}</span>
                      </span>
                    </div>
                    <span style="width: max-content; margin-left: 20%; white-space: nowrap;">{{ showChoiceTotal(showChoiceLabel(item, planIndex)) }}</span>
                  </div>
                </button-util>
              </td>
            </tr>
            
          </template>

          <!-- footer -->
          <tr>
            <td class="border-transparent pt-5" colspan="5">
              <span class="flex" style="align-items: center;">
                <span class="text-xl">*</span>
                <span style="color: #137D61; display: flex; justify-content: center; align-items: center; width: 1.7vw; height: 1.7vw; border: 0.15vw dashed #137D61; border-radius: 50%; margin-left: 0.2%;">
                  <span style="display: flex; justify-content: center; align-items: center; height: 80%; width: 80%;"></span>
                </span>
                <span style="color: #137D61; margin-left: 0.4%;" class="text-xl">Choice of items (e.g. 5 / 1 : Choose 1 out of the 5 available items)</span>
              </span>
            </td>
          </tr>
        </tbody>
    </table>

    <egg-description titleColor="#603813"  @click="showWebchat()"
      :eggImgObj="{ componentName: 'services', imgName: 'eggWithLine', imgFormat: 'svg', position: 'right' }"
      :isShowStarBackgroundRight="false" :isShowStarBackgroundLeft="false"
      :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', bottom: '-10%' }"
      textMode="text" label="services.findLookingFor" labelFontClassSize="text-6xl" labelColor="#603813"
      description="services.letUsCustomize" class="pb-8 my-20">

      <template #customButtonContent>
        <button-util buttonType="button" bgColor="transparent" class="button" labelColor="#FC5555"
          :buttonIcon="{ componentName: 'services', imgName: 'chat', imgFormat: 'svg', width: '2vw' }"
          style=" position: absolute;top: 20%;left: 35%;" >     
        </button-util>

        <span style="color:#FFE8C2;  position: absolute; top: 40%;left: 23%; width: 55%;">{{ t("services.arrange") }}</span>
      </template>

    </egg-description>

  </div>
</template>

<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useFooterStore } from "@/stores/footer";
import { useHeaderStore } from "@/stores/header";

const headerStore = useHeaderStore();
const footerStore = useFooterStore();
const servicesStore = useServicesStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

const WEBCHAT_URL = import.meta.env.WEBCHAT_URL;
const ENV = import.meta.env.MODE;
const collapsed = ref(true);

onMounted(async () => {
  // servicesStore.healthPackagesDetailList.splice(0, servicesStore.healthPackagesDetailList.length);
  // servicesStore.updateHealthPackagesDetailList();
  // servicesStore.updateHealthPackagesList();
  servicesStore.getAllPlanInfo();
});

const showWebchat = () => {
  console.log("env", ENV, WEBCHAT_URL);
  footerStore.isShowWebchat = true;
  //window.open(WEBCHAT_URL, "_blank", "noreferrer");
  //window.open(WEBCHAT_URL, "_self");
}

const downloadPDF = (attachmentName: string) => {
  servicesStore.downloadPDF(attachmentName);  
}

//not on home page, stop intro timer
router.beforeEach(async (to, from) => { });

const goTo = (refName) => { };

const routeTo = (position) => {
  headerStore.scrollToAppointmentForm = true;
  router.push({ name: position, params: { uid: "lczmx" } });
};

const currancyFormatter = (number) => {
  return "HK$" + number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};

const toggleDetail = (item) => {

  if (servicesStore.healthDetailToggleList.includes(item.headerGroupKey))
    servicesStore.healthDetailToggleList.splice(servicesStore.healthDetailToggleList.indexOf(item.headerGroupKey), 1)
  else
    servicesStore.healthDetailToggleList.push(item.headerGroupKey)
}

const getToggleColor = (item) => {

  if (item.isHeader) {
    if (servicesStore.healthDetailToggleList.includes(item.headerGroupKey))
      return 'expendHeader';
    else
      return 'noExpendHeader';
  }
  else {
    return ''
  }
}

const getToggleHeaderClass = (item) => {

  if (item.isHeader) {
    if (servicesStore.healthDetailToggleList.includes(item.headerGroupKey))
      return 'expendHeader';
    else
      return 'noExpendHeader';
  }
  else {
    return ''
  }
}

const getToggleButtonIcon = (item) => {

  if (servicesStore.healthDetailToggleList.includes(item.headerGroupKey))
    return { componentName: 'shared', imgName: 'upArrow', imgFormat: 'svg', width: '0.8vw' }
  else
    return { componentName: 'shared', imgName: 'downArrow', imgFormat: 'svg', width: '0.8vw' }
}

const newGetToggleButtonIcon = (category) => {
  // error handling, if no such category, keep no expand
  if (!servicesStore.showItemPerCategory.hasOwnProperty(category))
    return { componentName: 'shared', imgName: 'downArrow', imgFormat: 'svg', width: '0.8vw' };

  if (!servicesStore.showItemPerCategory[category])
    return { componentName: 'shared', imgName: 'downArrow', imgFormat: 'svg', width: '0.8vw' };
  else
    return { componentName: 'shared', imgName: 'upArrow', imgFormat: 'svg', width: '0.8vw' };
}

const newGetToggleColor = (category) => {
  // error handling, if no such category, keep no expand
  if (!servicesStore.showItemPerCategory.hasOwnProperty(category))
    return 'noExpendHeader';

  if (!servicesStore.showItemPerCategory[category])
    return 'noExpendHeader';
  else
    return 'expendHeader';
}

const toggleCollapse = (category) => {
  // error handling, if no such category, always hide
  if (!servicesStore.showItemPerCategory.hasOwnProperty(category))
    return false;

  servicesStore.showItemPerCategory[category] = !servicesStore.showItemPerCategory[category];
}

const showCategoryName = (category) => {
  // error handling, if no such category, show error
  if (!servicesStore.allPlanCategory.hasOwnProperty(category))
    return "Category Not Found";
  
  return servicesStore.allPlanCategory[category]["categoryName"]
}

const generateCategory = (item) => {
  if (item.isHeader) {
    // if there is such category, generate header
    if (servicesStore.allPlanCategory.hasOwnProperty(item.category))
      return true;
    else
      return false;
  }
  
  return item.isHeader;
}

const setCellBackgroundColor = (index) => {
  return index % 2 === 0 ? '#E1F9F7' : '#BFDAD8';
}

const showStarOrNot = (item, index) => {
  const currentPlanCode = servicesStore.allPlanInfo[index].code;
  const currentItemCode = item.itemCode;
  // console.log("SHOWSTAR: " + JSON.stringify(servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode)));

  // the plan include it
  let condition1 = servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode);

  let condition;
  
  if (condition1) {
    if (servicesStore.allPlanItemPerPlan[currentPlanCode][currentItemCode]["isChoice"])
      condition = false;
    else
      condition = true;
  } else {
    condition = false;
  }
  return condition;
}

const showChoiceOrNot = (item, index) => {
  const currentPlanCode = servicesStore.allPlanInfo[index].code;
  const currentItemCode = item.itemCode;
  // console.log("SHOWSTAR: " + JSON.stringify(servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode)));

  // the plan include it
  let condition1 = servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode);

  let condition;
  
  if (condition1) {
    if (servicesStore.allPlanItemPerPlan[currentPlanCode][currentItemCode]["isChoice"])
      condition = true;
    else
      condition = false;
  } else {
    condition = false;
  }

  return condition;
}

const showChoiceLabel = (item, index) => {

  const currentPlanCode = servicesStore.allPlanInfo[index].code;
  const currentItemCode = item.itemCode;
  // console.log("SHOWSTAR: " + JSON.stringify(servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode)));

  // the plan include it
  let condition1 = servicesStore.allPlanItemPerPlan[currentPlanCode].hasOwnProperty(currentItemCode);

  if (condition1) {
    return servicesStore.allPlanItemPerPlan[currentPlanCode][currentItemCode]["choiceGroup"];
  } else {
    return ''
  }
}

const checkIfNeedCollapse = (item) => {
  return servicesStore.showItemPerCategory[item.category];
}

const showChoiceTotal = (group) => {
  if (servicesStore.allPlanGroup.hasOwnProperty(group)) {
    return servicesStore.allPlanGroup[group]["total"] + " / " + servicesStore.allPlanGroup[group]["numOfChoice"]
  }
  else {
    return ""
  }
}

const calculateRowspan = (groupName, currentIndex) => {
  let rowspan = 1;
    for (let i = currentIndex + 1; i < servicesStore.allPlanItemInfo.length; i++) {
      if (servicesStore.allPlanItemInfo[i].groupName === groupName) {
        rowspan++;
      } else {
        if (!shouldRenderCell(servicesStore.allPlanItemInfo[i].groupName, i)) {
          rowspan++;
        }
        break;
      }
    }
    return rowspan;
  }

const calculateColspan = (groupName, itemName) => {
  let colspan = 1;
  if (groupName === itemName) {
      colspan++;
    }
  return colspan;
};

const isSameNameasGroup = (groupName, itemName) => {
  if (groupName === itemName) {
      return false;
  } else {
    return true;
  }
}

const shouldRenderCell = (groupName, currentIndex) => {
  const lastGroupName = servicesStore.allPlanItemInfo[currentIndex - 1]?.groupName;
  return groupName !== lastGroupName;
}

const showCategory = (item, index) => {
  if (item.category !== 'BASIC') {
    const previousItem = servicesStore.allPlanItemInfo[index - 1];
    return !previousItem || previousItem.category === 'BASIC';
  }
    return false;
}

</script>

<style lang="stylus"> scoped>
.dark-brown {
  color: var(--services-color);
}

td,
th {
  border: 0.1vw solid black;
}


.expendHeader{
  background-color: #215650; 
  color: white;
  th {
    border-color: #215650;
  }
}

.noExpendHeader{
  background-color: #488F82; 
  color: white;
  th {
    border-color: #488f83;
  }
}

#packageTitle{
  cursor: pointer;
}

#packageTitle:hover{
  color: black;
}

#exclusiveCheckUp{
  cursor: default;
}


</style> 
